<ul class="mobile-footer-language cursor-pointer" *ngIf="forPlace==='footer'">
  <li>
    <a  (click)="setLang('en')" style="background-image: url('/assets/flags/en.ico')"></a>
  </li>
  <li>
    <a (click)="setLang('ru')" style="background-image: url('/assets/flags/ru.ico')"></a>
  </li>
</ul>

<select class="custom-sel cursor-pointer" aria-label="Language" [(ngModel)]="lang" (ngModelChange)="setLang($event)" *ngIf="forPlace==='header'">
  <option value="en" style="background-image: url('/assets/flags/en.ico')">ENG</option>
  <option value="ru" style="background-image: url('/assets/flags/ru.ico')">РУС</option>
</select>
